import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense } from "react";
import { Global } from "@emotion/react";
import { Layout } from "./components/Layout/Layout";
import { ProtectedRoute } from "./components/Auth/ProtectedRoute";
import { GuestRoute } from "./components/Auth/GuestRoute";
import {
  LanguageWrapper,
  RootRedirect,
} from "./components/Layout/LanguageWrapper";
import { globalStyles } from "./styles/global";
import { appRoutes } from "./config/routes";
import { lazy } from "react";

const SpotPage = lazy(() => import("./pages/Spot/SpotPage").then(m => ({ default: m.SpotPage })));
const SupportTicketPage = lazy(() => import("./pages/Support/SupportTicketPage").then(m => ({ default: m.SupportTicketPage })));
import { PageLoader } from "./components/ui/PageLoader";
import { NotFound } from "./pages/NotFound/NotFound";

import { CookieConsent } from "./components/ui/CookieConsent";

export default function App() {
  const guestRoutes = appRoutes.filter(
    (route) => route.isPublic && route.guestOnly,
  );
  const publicRoutes = appRoutes.filter(
    (route) => route.isPublic && !route.guestOnly,
  );
  const protectedRoutes = appRoutes.filter((route) => !route.isPublic);

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Global styles={globalStyles} />
      <CookieConsent />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<RootRedirect />} />

          {/* Сторінка спота на вищому рівні (поза мовами) */}
          <Route path="/s/:shortCode" element={<SpotPage />} />

          {/* Головний блок з підтримкою мов */}
          <Route path="/:lang" element={<LanguageWrapper />}>
            {publicRoutes.map((route) => (
              <Route key={route.path} path={route.path} element={route.element} />
            ))}

            <Route element={<GuestRoute />}>
              {guestRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={route.element}
                />
              ))}
            </Route>

            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                {protectedRoutes.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={route.element}
                  />
                ))}
              </Route>
            </Route>
          </Route>

          {/* Чат підтримки винесений окремо під захистом, щоб не конфліктувати з базовим мапом роутів */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route
                path="/:lang/support/:ticketId"
                element={<SupportTicketPage />}
              />
              <Route path="/support/:ticketId" element={<SupportTicketPage />} />
            </Route>
          </Route>
          {/* Catch-all 404 route - show NotFound component */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
